var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ab53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36953e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2437",
    "data-name": "Group 2437",
    transform: "translate(-365 -305)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 60,
    cy: 60.5,
    rx: 60,
    ry: 60.5,
    transform: "translate(365 305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check_5_",
    "data-name": "check (5)",
    transform: "translate(402.797 279.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5078",
    "data-name": "Path 5078",
    d: "M14.015,101.907a4.638,4.638,0,0,1-3.284-1.361L.8,90.62a2.737,2.737,0,0,1,0-3.87h0a2.737,2.737,0,0,1,3.87,0l9.344,9.344,24.72-24.72a2.737,2.737,0,0,1,3.87,0h0a2.737,2.737,0,0,1,0,3.87L17.3,100.546A4.638,4.638,0,0,1,14.015,101.907Z",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCheck);
export default __webpack_public_path__ + "static/media/modal-check.ad23cbe643fc235ef26cd5205d1604ca.svg";
export { ForwardRef as ReactComponent };